<template>
	<div>
		<v-row v-if="isBloquearItem" class="mt-3">
			<v-col cols="6" sm="6" md="2" lg="2" xl="2" class="py-1">
				<label-personalizado nome-campo="Item"></label-personalizado>
				<span> {{ itemParaBloquear.item }}</span>
			</v-col>
			<v-col cols="6" sm="6" md="2" lg="2" xl="2" class="py-1">
				<label-personalizado nome-campo="Tipo"></label-personalizado>
				<span> {{ itemParaBloquear.tipo }}</span>
			</v-col>
			<v-col cols="6" sm="6" md="4" lg="4" xl="4" class="py-1">
				<label-personalizado nome-campo="Unidade Aquisição"></label-personalizado>
				<span> {{ itemParaBloquear.unidadeAquisicao }}</span>
			</v-col>
			<v-col cols="6" sm="6" md="2" lg="2" xl="2" class="py-1">
				<label-personalizado nome-campo="Preço"></label-personalizado>
				<span> {{ itemParaBloquear.valorUnitario | azCurrency(numeroCasasDecimaisValores) }} </span>
			</v-col>
			<v-col cols="6" sm="6" md="2" lg="2" xl="2" class="py-1">
				<label-personalizado nome-campo="Marca"></label-personalizado>
				<span> {{ itemParaBloquear.fornecedor.marca }}</span>
			</v-col>
		</v-row>
		<v-row v-if="isBloquearItem">
			<v-col cols="12" class="py-1">
				<label-personalizado nome-campo="Descrição"></label-personalizado>
				<texto-tooltip :texto="itemParaBloquear.descricao" :tamanho-maximo="textoTamanhoMaximo"></texto-tooltip>
			</v-col>
		</v-row>
		<label-personalizado
			v-if="isBloquearItemEmMassa"
			nome-campo="Itens Selecionados"
			class="mb-1 mt-3 py-1"
		></label-personalizado>
		<v-row v-if="isBloquearItemEmMassa" class="flex-column flex-lg-row flex-md-row flex-sm-row flex-xl-row">
			<template v-for="(item, index) in itensParaBloquear">
				<v-col
					:key="index"
					class="py-1"
					md="2"
					sm="12"
					v-if="!item.isBloqueado"
					:class="{ 'flex-sm-12': $vuetify.breakpoint.smAndDown, 'flex-md-2': $vuetify.breakpoint.mdAndUp }"
				>
					<span><texto-tooltip :texto="item.descricao" tamanho-maximo="40"></texto-tooltip></span>
				</v-col>
			</template>
		</v-row>
		<v-row class="mt-3">
			<v-col cols="12">
				<label-personalizado nome-campo="Motivo" obrigatorio-por-padrao class="mb-2"></label-personalizado>
				<v-textarea
					ref="justificativa"
					v-model="bloquear.justificativa"
					placeholder="Informe o motivo"
					:rules="regrasJustificativa"
					rows="1"
					counter="300"
					class="ma-0 py-0"
					no-resize
					@input="corrigirTexto"
				></v-textarea>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import { mutationTypes } from '@/core/constants'
import { mapState } from 'vuex'
import validacaoFormulario from '@/views/mixins/validacaoFormulario'

export default {
	name: 'bloqueio-item',
	components: {},
	mixins: [validacaoFormulario],
	props: {
		itemParaBloquear: {
			type: Object,
			default: function () {
				return null
			},
		},
		itensParaBloquear: {
			type: Array,
			default: null,
		},
	},
	data() {
		return {
			regrasJustificativa: [
				(value) => this.regraObrigatoriedade(value, 'O motivo é obrigatório.'),
				(value) =>
					this.regraDeTamanhoMaximoString(
						value,
						300,
						'O campo de motivo deve ser igual ou menor que 300 caracteres!',
					),
			],
			textoTamanhoMaximo: 400,
		}
	},
	computed: {
		...mapState({
			bloquear: (state) => state.itemAta.bloqueio.bloquear,
		}),
		numeroCasasDecimaisValores: {
			get() {
				return this.$store.state.ata.informacoesAta.numeroCasasDecimaisValores
			},
		},
		isBloquearItemEmMassa() {
			return !this.itemParaBloquear
		},
		isBloquearItem() {
			return !!this.itemParaBloquear
		},
	},
	mounted() {
		if (this.isBloquearItem) {
			this.bloquear.isBloquear = !this.itemParaBloquear.isBloqueado
		}
	},
	beforeDestroy() {
		this.$store.commit(mutationTypes.ITEM_ATA.BLOQUEIO.BLOQUEAR.RESET_BLOQUEAR)
	},
	methods: {
		montarDescricaoItem(item) {
			return `${item.codigo} - ${item.tipo}`
		},
		corrigirTexto() {
			this.bloquear.justificativa = this.bloquear.justificativa.trim()
		},
	},
}
</script>
<style lang="stylus" scoped>
.v-input--selection-controls
	margin-top: 3px !important
	padding-top: 0 !important
</style>
